import { Params } from '@angular/router';
import { StringSerializerBase } from './base/string.base';
import {
  QueryParamSerializer,
  QueryParamsKeys,
} from '../model/sidebar-query-params.model';

export class SearchStringSerializer
  extends StringSerializerBase
  implements QueryParamSerializer<string>
{
  public readonly key = QueryParamsKeys.sidebarSearchString;

  keyIsIn(params: Params): boolean {
    return Object.hasOwn(params, this.key);
  }

  deserializeQueryParamValue(value: string): string {
    return this.deserialize(value);
  }

  serializeToQueryParamValue(value: string): string {
    return this.serialize(value);
  }
}
